import { createFileRoute } from '@tanstack/react-router';

import { WeeklyPlansPage } from '@/features/siteplan/weekly-plans-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/weekly-plans')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <WeeklyPlansPage projectId={projectId} />;
}
